import React from "react";
import { useNavigate } from "react-router-dom";
import "./LoginSection.css";

export default function LoginSelectionPage() {
  const navigate = useNavigate();

  return (
    <div className="login-selection-container">
      <div className="login-box">
        <h1 className="login-title">Select Login Type</h1>

        <button
          className="login-btn"
          onClick={() => navigate("/admin-login")}
        >
          Login as Admin
        </button>

        <button
          className="login-btn"
          onClick={() => navigate("/manager-login")}
        >
          Login as Operational Manager
        </button>
        <button
          className="login-btn"
          onClick={() => navigate("/user")}
        >
         Open Screen
        </button>

      </div>
    </div>
  );
}
